import { useState, useCallback } from 'react'
import { ReferencedEntityWithBackgroundColor } from '../../../../domain/value-object/ReferencedEntity'
import { useWbsTagRepository } from '../../../../services/adaptors/wbsTagRepositoryAdaptor'

export const useWbsItemTagSearch = (projectUuid: string) => {
  const [fetched, setFetched] = useState<boolean>(false)
  const [tags, setTags] = useState<ReferencedEntityWithBackgroundColor[]>([])
  const { fetchListAsReferencedEntity } = useWbsTagRepository()
  const search = useCallback(
    async (searchText: string) => {
      if (!fetched) {
        const response = await fetchListAsReferencedEntity(projectUuid)
        setTags(response)
        setFetched(true)
        return response.filter(tag => tag.name.includes(searchText))
      }
      return tags.filter(tag => tag.name.includes(searchText))
    },
    [fetchListAsReferencedEntity, fetched, projectUuid, tags]
  )

  return search
}
